export class Calibration {
  zeroGas: any;
  spanGas: any;
  temparature: any;
  barometricPressure: any;
  humidity: any;
  spanGasConcentration: any;
}
